<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="试卷分类名称" prop="classificationId">
        <el-select v-model="form.classificationId" placeholder="请选择" clearable size="small">
          <el-option v-for="(item,index) in topicClassOptions" :key="index" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题目" prop="title">
        <el-input v-model="form.title" type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请输入题目内容" />
      </el-form-item>

      <el-form-item label="选项" prop="answerStr" required>
        <div class="table-list mt20">
          <div class="spec-head">
            <div class="sp-col">选项</div>
            <div class="sp-col flex2">内容</div>
            <div class="sp-col">正确答案</div>
            <div class="sp-col">操作</div>
          </div>
          <div class="spec-item" v-for="(it, idx) in form.answerStr" :key="idx">
            <div class="sp-col">
              {{xxType[idx]}}
            </div>
            <el-form-item class="sp-col flex2" :prop="`answerStr[${idx}].content`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'blur',}">
              <el-input v-model="it.content" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item class="sp-col" :prop="`answerStr[${idx}].isCorrect`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
              <el-switch v-model="it.isCorrect" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <div class="sp-col oper-icon">
              <i class="el-icon-minus" @click="deleteSeriveSpec(idx)" v-if="form.answerStr.length > 1"></i>
              <i class="el-icon-plus" @click="handleAdd"></i>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="题目解析" prop="resolutionContent">
        <el-input v-model="form.resolutionContent" type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请输入题目解析" />
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>{{form.state?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import courseTopicApi from '@/api/course/courseTopic'
function initFormBean() {
  const formBean = {
    id: null,
    title: null,
    state: 0,
    answerStr: [{ content: '', isCorrect: 0, imgUrl: '' }],
    resolutionContent: null
  }
  return formBean
}
export default {
  props: ['topicClassOptions'],
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      xxType: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'],
      formRules: {
        classificationId: [{ required: true, message: '请选择试卷分类名称', trigger: 'change' }],
        title: [{ required: true, message: '请输入题目内容', trigger: 'blur' }],
        resolutionContent: [{ required: true, message: '请输入题目解析', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {
  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    handleUpdate(row) {
      courseTopicApi.fetchById(row.id).then(res => {
        let data = res.data;
        this.form = data
        this.$set(this.form, 'answerStr', data.courseTopicAnswerList)
        delete this.form['courseTopicAnswerList']
        this.formVisible = true;
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })



    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      let isAnswer = []
      params.answerStr.forEach((item, index) => {
        item.code = this.xxType[index]
        item.orderNo = index + 1;
        if (item.isCorrect) {
          isAnswer.push(item.code)
        }
      })
      if (!isAnswer.length) return this.$message.error('请选择正确答案');
      params.answerStr = JSON.stringify(params.answerStr)
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            courseTopicApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseTopicApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleAdd() {
      let Obj = { content: '', isCorrect: 0, imgUrl: '' }
      this.form.answerStr.push(Obj)
    },
    deleteSeriveSpec(i) {
      this.form.answerStr.splice(i, 1);
    },

  }
}
</script>
<style lang="scss" scoped>
.hint {
  font-size: 12px;
  color: #999;
}
.hint-txt {
  margin-bottom: 20px;
  font-weight: bold;
  padding-left: 20px;
}

::v-deep .el-select {
  width: 100%;
}
// ::v-deep .el-input-number__decrease {
//   display: none;
// }
// ::v-deep .el-input-number__increase {
//   display: none;
// }
// ::v-deep .el-input-number .el-input__inner {
//   text-align: left;
// }

.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>
